export const common = {
  nav: {
    home: 'Laman Utama',
    about: 'Tentang',
    rooms: 'Bilik',
    gallery: 'Galeri',
    reservation: 'Tempahan',
    access: 'Akses',
    contact: 'Hubungi',
    forOwners: 'Untuk Pemilik Hartanah',
    freeConsultation: 'Perundingan Percuma',
  },
  hero: {
    title: 'Di Mana Tradisi Bertemu',
    subtitle: 'Keselesaan Moden',
    description: 'Rasai pesona autentik rumah tradisional Jepun di Magome, Ota-ku, Tokyo. Perpaduan sempurna antara keindahan bersejarah dan kemudahan kontemporari.',
    bookNow: 'Tempah Sekarang',
    viewGallery: 'Lihat Galeri',
  },
  about: {
    title: 'Tentang',
    subtitle: 'Perpaduan harmoni antara seni bina Jepun tradisional dan keselesaan moden',
    description: 'Rumah Tradisional Magome adalah sebuah rumah Jepun yang telah dipulihara dengan indah, terletak di kawasan perumahan tenang Magome, Ota-ku, Tokyo. Direnovasi dengan teliti untuk mengekalkan pesonanya yang tradisional sambil menawarkan kemudahan moden, memberikan peluang unik untuk merasai kehidupan Jepun yang autentik.',
    feature1Title: 'Keseluruhan Rumah',
    feature1Desc: 'Nikmati privasi penuh bersama keluarga dan rakan-rakan dalam sewaan eksklusif ini',
    feature2Title: 'Dapur Lengkap',
    feature2Desc: 'Dapur lengkap untuk menyediakan hidangan kegemaran anda',
    feature3Title: 'Sehingga 8 Tetamu',
    feature3Desc: 'Penginapan luas yang sesuai untuk kumpulan dan keluarga',
    feature4Title: 'Tatami Tradisional',
    feature4Desc: 'Bilik Jepun autentik dengan tikar tatami dan kehangatan kayu',
  },
  rooms: {
    title: 'Bilik',
    subtitle: 'Berehat di ruang bergaya Jepun tradisional',
    room1: 'Pelan Lantai',
    room2: 'Dapur Lengkap',
    room3: 'Katil Tambahan',
    capacity: 'Kapasiti Maksimum',
    guests: '8 Tetamu',
    amenities: 'Kemudahan',
    amenitiesList: 'Dapur lengkap, Peti sejuk, Ketuhar gelombang mikro, Peralatan memasak, Peralatan makan, Wi-Fi, Penghawa dingin, Pemanas, Mesin basuh, Bilik mandi, Tandas, Tuala, Kelengkapan mandi',
  },
  gallery: {
    title: 'Galeri',
    subtitle: 'Temui keindahan Rumah Tradisional Magome',
  },
  reservation: {
    title: 'Tempahan',
    subtitle: 'Tempah penginapan istimewa anda',
    name: 'Nama Penuh',
    email: 'Alamat E-mel',
    phone: 'Nombor Telefon',
    checkin: 'Daftar Masuk',
    checkout: 'Daftar Keluar',
    guests: 'Bilangan Tetamu',
    message: 'Permintaan Khas',
    submit: 'Hantar Tempahan',
    submitting: 'Menghantar...',
    success: 'Permintaan tempahan anda telah diterima. Kami akan menghubungi anda tidak lama lagi.',
    error: 'Gagal menghantar. Sila cuba lagi.',
    bookingPlatforms: 'Anda juga boleh menempah melalui platform ini',
    bookOnAirbnb: 'Semak ketersediaan & tempah di Airbnb',
    bookOnJalan: 'Semak ketersediaan & tempah di Jalan',
    orDirectBooking: 'atau hubungi kami terus',
    required: 'Wajib',
    guestsPlaceholder: '― Sila pilih ―',
    guestSingular: 'Tetamu',
    guestPlural: 'Tetamu',
    messagePlaceholder: 'Ada permintaan khas atau soalan? Sila tulis. (maks. 500 aksara)',
    confirmNote: '※ Kami akan menghubungi anda selepas mengesahkan permintaan tempahan.',
  },
  contact: {
    title: 'Hubungi',
    subtitle: 'Jangan teragak-agak untuk menghubungi kami dengan sebarang soalan atau pertanyaan',
    name: 'Nama Penuh',
    email: 'Alamat E-mel',
    subject: 'Subjek',
    message: 'Mesej',
    submit: 'Hantar',
    submitting: 'Menghantar...',
    success: 'Mesej anda telah diterima. Kami akan menghubungi anda tidak lama lagi.',
    error: 'Gagal menghantar. Sila cuba lagi.',
    address: 'Alamat',
    addressDetail: '〒143-0022 1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    access: 'Akses',
    accessDetail: '8 minit berjalan kaki dari Stesen Magome (Toei Asakusa Line)',
    faqBannerTitle: 'Sebelum menghantar, sila semak FAQ kami',
    faqBannerDesc: 'Kami telah menjawab banyak soalan biasa tentang harga, prosedur dan pengurusan.',
    faqBannerBtn: 'Lihat FAQ',
    accessInfoTitle: 'Maklumat Akses',
    sendMessageTitle: 'Hantar Mesej',
    inquiryType: 'Jenis Pertanyaan',
    inquiryTypePlaceholder: 'Pilih jenis pertanyaan',
    inquiryOptions: {
      minpaku: 'Pendaftaran Minpaku / Permohonan Permit',
      ryokan: 'Perolehan Lesen Ryokan',
      management: 'Pengurusan Hartanah / Operasi',
      pricing: 'Harga / Pelan',
      marketing: 'Penyenaraian Airbnb / Pemasaran',
      revenue: 'Simulasi Pendapatan',
      other: 'Lain-lain',
    },
    messagePlaceholder: 'Sila huraikan pertanyaan anda (maks. 500 aksara)',
    detailLabel: 'Butiran Perundingan',
    detailPlaceholder: 'Sila huraikan lokasi hartanah, keadaan semasa dan permintaan anda (maks. 500 aksara)',
  },
  access: {
    label: 'Akses',
    title: 'Akses & Peta',
    subtitle: 'Terletak di kawasan perumahan tenang Higashi-Magome, Ota-ku, Tokyo',
    addressLabel: 'Alamat',
    addressLine1: '1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    addressLine2: '〒143-0022 1-12-12 Higashi-Magome, Ota-ku, Tokyo',
    trainLabel: 'Dengan Kereta Api',
    trainLine1: '2 minit berjalan kaki dari Stesen Magome (Toei Asakusa Line)',
    trainLine2: '',
    busLabel: 'Dengan Bas',
    busLine1: '2 minit berjalan kaki dari perhentian bas "Magome Ekimae" (Toei Bus)',
    busLine2: '',
    parkingLabel: 'Tempat Letak Kereta',
    parkingLine1: 'Tempat letak kereta berbayar tersedia berdekatan',
    parkingLine2: 'Sila hubungi kami jika anda merancang untuk datang dengan kereta',
    openMap: 'Buka dalam Google Maps',
  },
  footer: {
    description: 'Sewaan rumah tradisional Jepun di Magome, Ota-ku, Tokyo. Rasai harmoni sempurna antara keindahan Jepun dan keselesaan moden.',
    quickLinks: 'Pautan Pantas',
    followUs: 'Ikuti Kami',
    rights: 'Hak cipta terpelihara.',
    napTitle: 'Pejabat Yokota — Perakaunan & Cukai',
    napAddress: '1-12-12 Higashi-Magome, Ota City, Tokyo',
    napAddressJa: '東京都大田区東馬込1-12-12',
    napPhone: 'Tel: Sila hubungi kami',
    napServiceArea: 'Kawasan Perkhidmatan: Ota City dan seluruh Tokyo',
    napAccess: 'Toei Asakusa Line — Stesen Magome',
  },
  stickyButton: {
    title: 'Perundingan 30 Minit',
    subtitle: 'Percuma',
  },
  ownersBanner: {
    subtitle: 'Untuk pemilik hartanah yang mempertimbangkan Airbnb di Tokyo',
    linkText: 'Ketahui tentang perkhidmatan sokongan untuk pemilik hartanah →',
  },
  airbnbLead: {
    title: 'Ingin Memulakan Airbnb di Tokyo?',
    description: 'Kami menyediakan sokongan menyeluruh — daripada pendaftaran minpaku dan perolehan lesen ryokan hingga pengurusan hartanah penuh. Berpangkalan di Bandar Ota dengan pengalaman operasi sebenar.',
    ctaButton: 'Dapatkan Perundingan Percuma',
    badge1: 'Perundingan tanpa obligasi',
    badge2: 'Pengalaman operasi sebenar',
    badge3: 'Sokongan penuh dari pelesenan hingga pengurusan',
  },
  trust: {
    badge: 'Mengapa Pilih Kami',
    title: 'Dipercayai oleh Pemilik Hartanah Tokyo',
    subtitle: 'Kami menggabungkan pengalaman operasi sebenar dengan sokongan komprehensif untuk membantu anda berjaya.',
    point1Title: 'Pengalaman Airbnb Sebenar',
    point1Description: 'Kami secara aktif mengendalikan penginapan tradisional kami sendiri di Bandar Ota. Nasihat kami berdasarkan pengalaman langsung, bukan teori.',
    point2Title: 'Sokongan Pelesenan Penuh',
    point2Description: 'Dari pendaftaran minpaku hingga perolehan lesen ryokan — kami mengendalikan semua dokumen dan komunikasi dengan pihak berkuasa.',
    point3Title: 'Pengoptimuman Pendapatan',
    point3Description: 'Strategi penetapan harga berasaskan data dari data pasaran Tokyo sebenar. Purata peningkatan pendapatan 30%+ untuk pelanggan kami.',
    point4Title: 'Sokongan Tetamu 24/7',
    point4Description: 'Komunikasi tetamu berbilang bahasa sepanjang masa agar anda fokus pada pendapatan, bukan pengurusan.',
    point5Title: 'Laporan Telus',
    point5Description: 'Laporan pendapatan bulanan dan struktur yuran yang jelas. Tiada kos tersembunyi, tiada kejutan.',
    ctaButton: 'Terokai Perkhidmatan Kami',
  },
  howItWorks: {
    title: 'Cara Ia Berfungsi',
    subtitle: 'Proses mudah dan telus dari perundingan hingga pelancaran yang berjaya',
    step1Number: '01',
    step1Title: 'Perundingan Percuma',
    step1Desc: 'Kongsi butiran dan matlamat hartanah anda. Kami memberikan nasihat jujur tentang pelesenan, potensi pendapatan, dan langkah seterusnya.',
    step2Number: '02',
    step2Title: 'Penilaian Hartanah',
    step2Desc: 'Kami menilai kesesuaian hartanah anda, mengenal pasti keperluan, dan mencipta pelan tindakan yang disesuaikan.',
    step3Number: '03',
    step3Title: 'Pelancaran & Sokongan',
    step3Desc: 'Dari permohonan lesen hingga pengurusan tetamu, kami mengendalikan segalanya agar anda fokus pada pendapatan.',
    ctaButton: 'Tempah Perundingan Percuma Anda',
    ctaNote: '30 minit • Tanpa obligasi • Peta jalan yang jelas',
  },
  urgency: {
    title: 'Ingin Memulakan Airbnb di Tokyo?',
    description: 'Peraturan pelesenan adalah kompleks dan kesilapan boleh melambatkan pelancaran anda. Dapatkan nasihat yang jelas dan praktikal sebelum membuat keputusan.',
    ctaButton: 'Tempah Perundingan Percuma',
    note: 'Perundingan 30 minit • Tanpa obligasi • Pengalaman sebenar',
  },
  trustRisk: {
    title: 'Perundingan Tanpa Tekanan',
    description: 'Kami memberikan nasihat praktikal berdasarkan pengalaman sebenar. Walaupun anda memutuskan untuk tidak meneruskan, anda akan mendapat peta jalan yang jelas.',
    badge1Title: 'Tanpa Obligasi',
    badge1Desc: 'Nasihat percuma tanpa tekanan',
    badge2Title: 'Pengalaman Sebenar',
    badge2Desc: 'Kami mengendalikan hartanah kami sendiri',
    badge3Title: 'Peta Jalan Jelas',
    badge3Desc: 'Panduan yang boleh terus dilaksanakan',
    whatYouGetTitle: 'Apa Yang Anda Akan Dapat dari Perundingan Kami',
    item1: 'Penilaian jujur tentang potensi hartanah anda',
    item2: 'Penjelasan jelas tentang keperluan pelesenan dan jadual',
    item3: 'Unjuran pendapatan realistik berdasarkan lokasi anda',
    item4: 'Peta jalan langkah demi langkah yang boleh anda ikuti secara bebas',
    ctaButton: 'Jadualkan Perundingan Percuma Anda',
    ctaNote: 'Tersedia Isnin–Jumaat, 9:00–18:00 JST',
  },
  faq: {
    title: 'Soalan Lazim',
    subtitle: 'Soalan umum tentang memulakan dan mengendalikan perniagaan Airbnb dan Minpaku di Tokyo',
    ctaText: 'Ada soalan lagi? Kami sedia membantu.',
    ctaButton: 'Tempah Perundingan Percuma',
    q1: 'Bagaimana untuk memulakan Airbnb di Tokyo?',
    a1: 'Memulakan Airbnb di Tokyo memerlukan pelesenan yang betul. Terdapat dua pilihan utama: pendaftaran Minpaku (penginapan kediaman) atau lesen Ryokan (penginapan mudah). Minpaku membenarkan operasi sehingga 180 hari setahun dan memerlukan pendaftaran dengan pihak berkuasa tempatan. Lesen Ryokan membenarkan operasi sepanjang tahun tanpa had hari. Walau bagaimanapun, memerlukan pemenuhan piawaian kemudahan, peralatan keselamatan kebakaran, dan pemeriksaan berkala yang lebih ketat.',
    q2: 'Apakah perbezaan antara Minpaku dan lesen Ryokan?',
    a2: 'Minpaku adalah pendaftaran penginapan kediaman yang membenarkan pemilik hartanah menyewakan rumah mereka sehingga 180 hari setahun. Keperluan lebih mudah tetapi ada had operasi. Ryokan adalah lesen perniagaan penginapan mudah yang membenarkan operasi sepanjang tahun tanpa had hari. Walau bagaimanapun, memerlukan pemenuhan piawaian kemudahan, peralatan keselamatan kebakaran, dan pemeriksaan berkala yang lebih ketat.',
    q3: 'Bolehkah orang asing memulakan Airbnb di Jepun?',
    a3: 'Ya, orang asing boleh memulakan perniagaan Airbnb di Jepun, tetapi terdapat keperluan penting. Anda mesti mempunyai status kediaman yang sesuai yang membenarkan aktiviti perniagaan di Jepun. Pemilikan hartanah atau perjanjian sewa yang sah diperlukan, dan anda mesti melantik wakil pengurusan yang tinggal di Jepun dan boleh bertindak balas terhadap isu dalam masa 30 minit.',
    q4: 'Berapa lama pendaftaran Minpaku di Tokyo?',
    a4: 'Pendaftaran Minpaku di Tokyo biasanya mengambil masa 2–4 bulan dari persediaan awal hingga kelulusan. Jadualnya merangkumi: penilaian dan persediaan hartanah (2–3 minggu), persediaan dokumen dan pemeriksaan keselamatan kebakaran (2–4 minggu), penyerahan kepada kerajaan tempatan (pemprosesan 1–2 minggu), dan kelulusan dan pendaftaran akhir (1–2 minggu).',
    q5: 'Berapakah kos untuk memulakan?',
    a5: 'Kos berbeza-beza bergantung pada skop perkhidmatan dan keadaan hartanah anda. Kami menawarkan pelan yang merangkumi sokongan permohonan, persediaan dokumen, dan penilaian di tapak. Untuk perkhidmatan pengurusan hartanah, kami menggunakan struktur yuran berasaskan prestasi — peratusan daripada pendapatan — supaya anda boleh bermula dengan kos pendahuluan yang minimum.',
    q6: 'Apa yang boleh anda kendalikan jika saya mendapati pengurusan sendiri sukar?',
    a6: 'Kami boleh mengendalikan segalanya — pengurusan tempahan, komunikasi tetamu, penyelarasan pembersihan, serah terima kunci, penyelesaian isu, dan laporan pendapatan bulanan. Pemilik hartanah pada dasarnya boleh menjalankan operasi Airbnb tanpa perlu turun tangan sendiri.',
    q7: 'Bolehkah saya menjalankan Airbnb di kondominium?',
    a7: 'Menjalankan Airbnb di kondominium adalah mungkin selagi tidak dilarang oleh peraturan pengurusan bangunan. Anda perlu menyemak peraturan pengurusan terlebih dahulu untuk mengesahkan tiada klausa yang melarang aktiviti penginapan atau sewaan jangka pendek.',
    q8: 'Saya bimbang tentang aduan daripada jiran. Bagaimana anda menanganinya?',
    a8: 'Kami menetapkan peraturan rumah yang jelas untuk tetamu (bunyi bising, pelupusan sampah, penggunaan kawasan awam, dll.) dan menerangkannya dengan teliti semasa daftar masuk untuk mencegah masalah sebelum berlaku. Jika ada aduan, kami mempunyai sistem tindak balas 24 jam untuk menilai dan menangani situasi dengan cepat.',
    q9: 'Berapa pendapatan yang boleh saya jangkakan?',
    a9: 'Pendapatan berbeza-beza dengan ketara bergantung pada lokasi, saiz, kemudahan, dan kadar penghunian hartanah. Di kawasan popular Tokyo, hartanah 1LDK hingga 2LDK boleh menjana pendapatan bulanan ¥200,000–¥500,000 dalam sesetengah kes. Kami menawarkan simulasi pendapatan percuma berdasarkan data operasi masa lalu kami.',
    q10: 'Bolehkah saya hanya berunding sahaja? Adakah saya akan dipaksa menandatangani kontrak?',
    a10: 'Sudah tentu — perundingan sahaja amat dialu-alukan. Kami tidak pernah memaksa anda menandatangani kontrak di tempat. Kami berharap anda akan mengambil masa dan membuat keputusan mengikut rentak anda sendiri.',
  },
  seo: {
    home: {
      title: 'Magome Kominka | Rumah Tradisional Jepun Tokyo & Pengurusan Airbnb',
      description: 'Menginap di rumah tradisional Jepun di Magome, Ota-ku, Tokyo — sewa keseluruhan rumah hingga 8 orang. Pengurusan Airbnb profesional dan sokongan lesen minpaku oleh hos aktif.',
      keywords: 'Magome Kominka, Tokyo Airbnb, Ota City minpaku, rumah tradisional Jepun, sewaan jangka pendek Tokyo',
    },
    management: {
      title: 'Perkhidmatan Pengurusan Airbnb Tokyo | Sewaan Jangka Pendek Lengkap',
      description: 'Pengurusan Airbnb profesional di Tokyo. Komunikasi tetamu, penetapan harga dinamik, penyelarasan pembersihan dan laporan bulanan. Pengurusan sewaan jangka pendek lengkap untuk pemilik di Ota City dan Tokyo.',
      keywords: 'pengurusan Airbnb Tokyo, sewaan jangka pendek Tokyo, pengurusan hartanah Ota City, perkhidmatan tetamu Tokyo',
    },
    support: {
      title: 'Sokongan Minpaku & Lesen Ryokan Tokyo | Pelancaran Perniagaan Penginapan',
      description: 'Sokongan pakar untuk pendaftaran minpaku dan permohonan lesen ryokan di Tokyo. Panduan praktikal dari hos aktif di Ota City — dari dokumen pentadbiran hingga pelancaran pendapatan.',
      keywords: 'pendaftaran minpaku Tokyo, lesen ryokan Tokyo, sokongan Airbnb Tokyo, sewaan jangka pendek Ota City',
    },
    forOwners: {
      title: 'Pengurusan Airbnb Tokyo & Sokongan Lesen Minpaku untuk Pemilik Hartanah',
      description: 'Pengurusan Airbnb lengkap dan sokongan lesen minpaku untuk pemilik hartanah di Tokyo. Dari pelesenan hingga operasi harian dan pembersihan — sokongan penuh. Perundingan percuma.',
      keywords: 'pemilik Airbnb Tokyo, sokongan lesen minpaku, pengurusan hartanah Tokyo, Airbnb Ota City',
    },
    pricing: {
      title: 'Harga Pengurusan Airbnb Tokyo | Pelan Telus untuk Pemilik Hartanah',
      description: 'Harga jelas dan telus untuk pengurusan Airbnb dan sokongan minpaku di Tokyo. Sokongan pelancaran, persediaan lengkap, perkhidmatan pengurusan dan pakej pembersihan. Tiada yuran tersembunyi.',
      keywords: 'harga pengurusan Airbnb Tokyo, kos sokongan minpaku, pelan sewaan jangka pendek Tokyo, yuran pengurusan Tokyo',
    },
    minpakuRegistration: {
      title: 'Pendaftaran Minpaku Tokyo | Panduan Langkah demi Langkah Lesen Ryokan',
      description: 'Panduan lengkap pendaftaran minpaku di Tokyo. Proses permohonan lesen ryokan, dokumen yang diperlukan, jadual dan kesilapan biasa — berdasarkan pengalaman operasi sebenar di Ota City.',
      keywords: 'pendaftaran minpaku Tokyo, lesen ryokan Tokyo, sokongan Airbnb Tokyo, sewaan jangka pendek Ota City',
    },
    guide: {
      title: 'Panduan Permulaan Minpaku Tokyo 2026 | Lesen, Pendapatan & Pengurusan',
      description: 'Panduan lengkap memulakan perniagaan Airbnb di Tokyo. Minpaku vs Ryokan, langkah pelesenan, jadual, kesilapan biasa, anggaran pendapatan dan bila menggunakan perkhidmatan pengurusan.',
      keywords: 'panduan minpaku Tokyo, mulakan Airbnb Tokyo, lesen minpaku, lesen ryokan, sewaan jangka pendek Tokyo',
    },
    caseStudy: {
      title: 'Kajian Kes Pelancaran Minpaku Ota City | Kisah Kejayaan Airbnb Tokyo',
      description: 'Kajian kes sebenar: Pemilik hartanah di Ota City melancarkan Airbnb dalam 3.5 bulan dengan lesen Ryokan, mencapai ¥180,000+/bulan dan kadar penghunian 78%. Sokongan minpaku Tokyo dalam amalan.',
      keywords: 'Ota City minpaku, kajian kes Airbnb Tokyo, lesen ryokan Tokyo, pengurusan Airbnb Tokyo',
    },
    adsLanding: {
      title: 'Mulakan Perniagaan Airbnb Sah di Tokyo | Sokongan Lesen Minpaku & Ryokan',
      description: 'Sokongan profesional lesen minpaku dan ryokan di Tokyo. Pengurusan Airbnb end-to-end dari hos aktif di Ota City. Perundingan percuma 30 minit. Sokongan pelancaran dari ¥300,000.',
      keywords: 'Airbnb sah Tokyo, sokongan lesen minpaku, permohonan ryokan Tokyo, pelancaran Airbnb Ota City',
    },
    airbnbGuide: {
      title: 'Panduan Undang-Undang Airbnb Tokyo | Panduan Lengkap Lesen Minpaku & Ryokan',
      description: 'Panduan lengkap memulakan Airbnb secara sah di Tokyo. Pendaftaran minpaku, keperluan lesen ryokan, kos, jadual dan proses langkah demi langkah — berdasarkan pengalaman operasi sebenar di Ota City.',
      keywords: 'lesen Airbnb Tokyo, pendaftaran minpaku Tokyo, lesen ryokan Tokyo, pengurusan Airbnb Tokyo, sewaan jangka pendek Ota City',
    },
  },
  schema: {
    management: {
      offerDescription: '15%–20% daripada pendapatan bulanan',
      service1: 'Pelarasan harga & penetapan harga dinamik',
      service2: 'Komunikasi tetamu (pelbagai bahasa)',
      service3: 'Pengurusan ulasan',
      service4: 'Penyelarasan pembersihan & linen',
      service5: 'Laporan pendapatan bulanan',
      service6: 'Program bantuan pemfailan cukai',
    },
  },
  taxOffice: {
    badge: 'Pejabat Perakaunan & Cukai',
    sectionTitle: 'Pejabat Yokota — Perakaunan & Cukai',
    sectionSubtitle: 'Pakar sokongan cukai minpaku di Higashi-Magome, Ota City, Tokyo',
    businessName: 'Pejabat Yokota — Perakaunan & Cukai',
    businessNameEn: 'Yokota Tax & Accounting Office',
    addressLabel: 'Alamat',
    addressJa: '東京都大田区東馬込1-12-12',
    addressEn: '1-12-12 Higashi-Magome, Ota City, Tokyo, Japan',
    serviceAreaLabel: 'Kawasan Perkhidmatan',
    serviceArea: 'Ota City dan seluruh Tokyo',
    serviceAreaEn: 'Ota City and Greater Tokyo',
    accessLabel: 'Akses',
    accessJa: 'Toei Asakusa Line — Stesen Magome',
    accessEn: 'Toei Asakusa Line — Magome Station',
    openMapBtn: 'Buka dalam Google Maps',
    supportTitle: 'Sokongan Cukai Minpaku & Airbnb',
    supportItems: [
      'Sistem bantuan pemfailan cukai (bukan perwakilan cukai)',
      'Sokongan cukai minpaku di Ota City',
      'Perundingan cukai Airbnb Tokyo',
      'Sokongan cukai minpaku Tokyo — perundingan pertama percuma',
      'Perundingan cukai Airbnb Tokyo — bantuan pelaporan pendapatan',
    ],
    disclaimer: '※ "Sistem bantuan pemfailan cukai" merujuk kepada bantuan penyediaan dokumen dan nasihat. Ini bukan perwakilan cukai.',
    officeImageAlt: 'Pejabat Yokota — Pejabat perakaunan di Higashi-Magome, Ota City',
    officeImageCaption: 'Pejabat Yokota — Higashi-Magome, Ota City, Tokyo',
    officeImageSubCaption: 'Sokongan cukai minpaku Ota City · Perundingan cukai Airbnb Tokyo',
  },
  managementContact: {
    title: 'Borang Perundingan Percuma',
    name: 'Nama Penuh',
    nameRequired: 'Wajib',
    phone: 'Nombor Telefon',
    email: 'Alamat E-mel',
    emailRequired: 'Wajib',
    propertyType: 'Jenis Hartanah',
    propertyTypePlaceholder: 'Sila pilih',
    propertyTypeOptions: {
      mansion1k: 'Apartmen（Studio–1LDK）',
      mansion2ldk: 'Apartmen（2LDK+）',
      house: 'Rumah Teres',
      kominka: 'Rumah Tradisional',
      taxConsult: 'Perundingan Cukai',
      other: 'Lain-lain',
    },
    consultContent: 'Butiran Perundingan',
    consultContentRequired: 'Wajib',
    consultContentCounter: '{{count}}/500 aksara',
    consultContentPlaceholder: 'Sila huraikan lokasi hartanah, keadaan semasa dan permintaan anda（maks. 500 aksara）',
    submit: 'Mohon Perundingan Percuma',
    submitting: 'Menghantar...',
    success: 'Terima kasih atas pertanyaan anda. Kami akan menghubungi anda dalam 2 hari bekerja.',
    error: 'Gagal menghantar. Sila cuba lagi.',
    beforeContact: 'Sebelum Menghubungi Kami',
    infoItems: [
      'Perundingan pertama percuma sepenuhnya',
      'Terutamanya melayani kawasan Tokyo',
      'Balas dalam 2 hari bekerja',
      'Maklumat peribadi anda dilindungi ketat',
    ],
    recommendTitle: 'Kami Syorkan Berunding Jika Anda…',
    recommendItems: [
      'Mempunyai hartanah tetapi tidak boleh mengurusnya sendiri',
      'Ingin memulakan Minpaku sebagai perniagaan sampingan',
      'Tidak berpuas hati dengan pendapatan semasa',
      'Sedang mencari perkhidmatan pembersihan',
      'Tidak tahu cara menggunakan Airbnb',
    ],
    confirmNote: 'Selepas pengesahan, kakitangan kami akan menghubungi anda.',
  },
  privateDriver: {
    badge: 'Perkhidmatan Rakan Kongsi',
    title: 'Pemandu Peribadi',
    titleEn: 'Private Driver Service',
    description: 'Pemandu rakan kongsi kami menyediakan pengangkutan profesional — dari pemindahan lapangan terbang hingga lawatan pelancongan.',
    descriptionHighlight: 'Pemandu berbahasa Inggeris tersedia.',
    featureTitle: 'Mengapa Pilih Perkhidmatan Kami',
    features: [
      { title: 'Pemandu Berbahasa Inggeris', desc: 'Pemandu profesional berbahasa Inggeris untuk tetamu antarabangsa.' },
      { title: 'Selamat & Dilindungi', desc: 'Pemandu profesional yang dilindungi sepenuhnya menjamin perjalanan yang selamat dan selesa.' },
      { title: 'Tersedia 24/7', desc: 'Penerbangan awal pagi atau ketibaan lewat malam — kami sentiasa bersedia dengan tempahan awal.' },
      { title: 'Bagasi Besar OK', desc: 'Kenderaan besar tersedia untuk keluarga. Beberapa beg pakaian bukan masalah.' },
      { title: 'Laluan Tersuai', desc: 'Laluan khas ke spot retro Showa dan lokasi pemotretan tersedia atas permintaan.' },
    ],
    menuTitle: 'Menu Perkhidmatan',
    priceGuide: 'Panduan Harga',
    pricingTitle: 'Panduan Harga',
    pricingNote: 'Semua harga termasuk cukai. Anggaran sahaja — hubungi kami untuk sebut harga tepat.',
    discountBadge: 'Diskaun Eksklusif',
    discountTitle: 'Khusus Tetamu',
    discountOff: 'DISKAUN 10%',
    discountSuffix: 'Diskaun Istimewa',
    discountNote: 'Nyatakan penginapan anda semasa menempah untuk mendapat diskaun.',
    discountBtn: 'Tempah Sekarang',
    ctaBadge: 'Eksklusif untuk Tetamu KOMINKA',
    ctaTitle: 'Harga Istimewa untuk Tetamu',
    ctaDesc: 'Tetamu KOMINKA menikmati diskaun eksklusif untuk perkhidmatan pemandu peribadi kami.',
    ctaBtn: 'Tempah Pemandu',
    officialPartner: 'Official Partner',
    officialPartnerJa: '提携サービス',
    services: [
      { title: 'Pemindahan Lapangan Terbang', subtitle: '空港送迎', desc: 'Penjemputan & penghantaran lapangan terbang Haneda/Narita. Perkhidmatan meet & greet tersedia.', price: 'Dari ¥8,000' },
      { title: 'Lawatan Bandar Tokyo', subtitle: '東京観光ドライブ', desc: 'Terokai kawasan era Showa, kuil dan permata tersembunyi bersama pemandu tempatan.', price: 'Dari ¥15,000/3j' },
      { title: 'Sokongan Penginapan Lama', subtitle: '長期滞在サポート', desc: 'Perkhidmatan pemandu mingguan atau bulanan untuk membeli-belah dan lawatan sehari.', price: 'Dari ¥40,000/minggu' },
      { title: 'Perjalanan Lokasi Foto', subtitle: '撮影ロケ送迎', desc: 'Pengangkutan ke spot era Showa ikonik dan lokasi filem.', price: 'Dari ¥12,000/2j' },
    ],
    pricing: [
      { title: 'Pemindahan Lapangan Terbang', subtitle: 'Airport Transfer', rows: [{ label: 'Lapangan Terbang Haneda ⇔ Magome (sehala)', price: '¥8,000+' }, { label: 'Lapangan Terbang Narita ⇔ Magome (sehala)', price: '¥14,000+' }, { label: 'Tambahan malam (22:00–6:00)', price: '+¥2,000' }, { label: 'Bagasi besar (3+ beg)', price: '+¥1,000' }], note: '* Harga sama untuk sehingga 4 penumpang' },
      { title: 'Lawatan Bandar Tokyo', subtitle: 'Tokyo City Tour', rows: [{ label: 'Kursus 3 jam', price: '¥15,000+' }, { label: 'Kursus 5 jam', price: '¥22,000+' }, { label: 'Sepanjang hari (8 jam)', price: '¥35,000+' }, { label: 'Laluan khas Showa Retro', price: '+¥3,000' }], note: '* Yuran pemandu & tempat letak kereta termasuk' },
      { title: 'Perjalanan Lokasi Foto', subtitle: 'Photo Location Drive', rows: [{ label: 'Kursus 2 jam', price: '¥12,000+' }, { label: 'Kursus 4 jam', price: '¥20,000+' }, { label: 'Pilihan pemandu lokasi', price: '+¥2,000' }, { label: 'Pengendalian peralatan/bagasi besar', price: '+¥1,500' }], note: '* Perundingan laluan tersedia terlebih dahulu' },
      { title: 'Sokongan Penginapan Lama', subtitle: 'Long Stay Support', rows: [{ label: 'Pelan sekali seminggu (4x/bulan)', price: '¥40,000+' }, { label: 'Pelan dua kali seminggu (8x/bulan)', price: '¥72,000+' }, { label: 'Penggunaan tunggal (3 jam)', price: '¥12,000+' }, { label: 'Membeli-belah/hospital', price: '¥6,000+/perjalanan' }], note: '* Diskaun 10% dengan bayaran bulanan' },
    ],
  },
};

export default common;
